import { html } from 'lit';
const BlockLink =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M3.25 6A2.75 2.75 0 0 1 6 3.25h2.5A2.75 2.75 0 0 1 11.25 6v2.5a2.75 2.75 0 0 1-2.75 2.75H6A2.75 2.75 0 0 1 3.25 8.5zM6 4.75c-.69 0-1.25.56-1.25 1.25v2.5c0 .69.56 1.25 1.25 1.25h2.5c.69 0 1.25-.56 1.25-1.25V6c0-.69-.56-1.25-1.25-1.25zM12.75 6a2.75 2.75 0 0 1 2.75-2.75H18A2.75 2.75 0 0 1 20.75 6v2.5A2.75 2.75 0 0 1 18 11.25h-2.5a2.75 2.75 0 0 1-2.75-2.75zm2.75-1.25c-.69 0-1.25.56-1.25 1.25v2.5c0 .69.56 1.25 1.25 1.25H18c.69 0 1.25-.56 1.25-1.25V6c0-.69-.56-1.25-1.25-1.25zM3.25 15.5A2.75 2.75 0 0 1 6 12.75h2.5a2.75 2.75 0 0 1 2.75 2.75V18a2.75 2.75 0 0 1-2.75 2.75H6A2.75 2.75 0 0 1 3.25 18zM6 14.25c-.69 0-1.25.56-1.25 1.25V18c0 .69.56 1.25 1.25 1.25h2.5c.69 0 1.25-.56 1.25-1.25v-2.5c0-.69-.56-1.25-1.25-1.25zm8.25-.75a.75.75 0 0 1 .75-.75h4.9a.85.85 0 0 1 .85.85v4.9a.75.75 0 0 1-1.5 0v-3.19l-5.22 5.22a.75.75 0 1 1-1.06-1.06l5.22-5.22H15a.75.75 0 0 1-.75-.75" clip-rule="evenodd"/>
  </svg>
`;
export default BlockLink;
